/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForVulnerabilitiesOci extends models.GovernanceConfigurationBaseForVulnerabilities {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForVulnerabilitiesOci");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForVulnerabilitiesOci.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForVulnerabilitiesOci>): GovernanceConfigurationForVulnerabilitiesOci {
        let obj = Object.assign(new GovernanceConfigurationForVulnerabilitiesOci(), model);
        GovernanceConfigurationForVulnerabilitiesOci.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForVulnerabilitiesOci>): GovernanceConfigurationForVulnerabilitiesOci {
        if (!model) return null;
        return GovernanceConfigurationForVulnerabilitiesOci.newInstance(<GovernanceConfigurationForVulnerabilitiesOci> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForVulnerabilitiesOci) {
        if (!obj) return;

        models.GovernanceConfigurationForVulnerabilitiesOci.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForVulnerabilitiesOci): boolean {
        if (models.GovernanceConfigurationBaseForVulnerabilities.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForVulnerabilitiesOci.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Specified whether host scan enabled or not
     */
    host_scan_enabled: boolean;

}
